import React from 'react';
import './HistoryArea.css';

function HistoryArea() {
  const journeys = [
    {
      year: "2019",
      title: "The Genesis",
      description: "In 2019, we launched our flagship cloud platform, dlupload.com, which scaled to 350,000+ users globally. This was the spark that ignited our mission to empower creators with high-performance digital tools.",
      image: "/img/dl3.jpg",
      delay: "200ms"
    },
    {
      year: "2021",
      title: "Team Expansion",
      description: "2021 was about scaling our talent. We brought together the brightest minds in creative direction and engineering, allowing us to pivot into high-intensity content production and strategic brand growth.",
      image: "/img/hero-banner.jpg",
      delay: "300ms"
    },
    {
      year: "2022",
      title: "Global Footprint",
      description: "We established a major presence in Australia, bridging the gap between APAC talent and global markets. Our reputation as a premium technology and content partner was solidified through high-impact collaborations.",
      image: "/img/timeline-3.jpg",
      delay: "400ms"
    },
    {
      year: "2024",
      title: "Industry Mastery",
      description: "A landmark year. Recognized by APAC Insider for innovation and placing in the top 3 at GSEA Nepal. We continue to dominate the intersection of tech and content, driving unprecedented growth for our clients.",
      image: "/img/timeline-4.jpg",
      delay: "500ms"
    }
  ];

  return (
    <section className="history-area sec-mar">
      <div className="container">
        <div className="title-wrap">
          <div className="sec-title wow animate fadeInUp">
            <span>Our Journey</span>
            <h2>Evolutionary Path</h2>
            <p>From a small tech collective to a global content engine, explore the key milestones that defined our growth and pursuit of digital excellence.</p>
          </div>
        </div>

        <div className="history-area-container">
          {journeys.map((item, index) => (
            <div key={index} className="single-history-modern">
              <div className="timeline-node"></div>
              
              <div className={`history-card-side wow animate ${index % 2 === 0 ? 'fadeInLeft' : 'fadeInRight'}`} data-wow-delay={item.delay}>
                <div className="history-card">
                  <div className="year-label">{item.year}</div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>

              <div className={`history-media-side wow animate ${index % 2 === 0 ? 'fadeInRight' : 'fadeInLeft'}`} data-wow-delay={item.delay}>
                <div className="history-media">
                  <img src={process.env.PUBLIC_URL + item.image} alt={item.title} />
                  <div className="media-glow"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HistoryArea;
